import React, { PropsWithChildren, ReactNode } from "react";
import { Typography } from "uiLibrary/designSystem/Typography/Typography";

export interface ProductSectionCardProps extends PropsWithChildren<{}> {
  dataTestId?: string;
  icon: ReactNode;
  title: string;
  description: string;
  price?: string;
}

export const ProductSectionCard = ({
  dataTestId = "product-card",
  icon,
  title,
  description,
  children,
  price
}: ProductSectionCardProps) => {
  const moduleName = "product-section-card";

  return (
    <div data-testid={dataTestId} className={`${moduleName}`}>
      <div className={`${moduleName}__main-area`}>
        <div className={`${moduleName}__header`}>
          <div className={`${moduleName}__icon-title-wrapper`}>
            <div data-testid={`${dataTestId}-icon-slot`} className={`${moduleName}__icon`}>
              {icon}
            </div>
            <Typography
              category="Headline"
              data-testid={`${dataTestId}-title`}
              size={300}
              weight="Heavy">
              {title}
            </Typography>
          </div>
        </div>
        {price && (
          <Typography
            data-testid={`${dataTestId}-price-per-year`}
            category={"Paragraph"}
            weight={"Heavy"}
            size={100}
            className={`${moduleName}__price`}>
            {price}
          </Typography>
        )}
        <Typography
          category="Paragraph"
          size={200}
          weight="Light"
          data-testid={`${dataTestId}-description`}>
          {description}
        </Typography>
        {children}
      </div>
    </div>
  );
};
